import { AuthRep, AccountSettings, AuthRepAddForm, AuthRepEditForm, GetMyMedicareCardPage } from './pages'
import { Route, Switch, useRouteMatch } from 'react-router-dom'
import { AuthenticatedRoute } from 'components/AuthenticatedRoute/AuthenticatedRoute'
import { Error404 } from 'Error404'
import { LaunchDarklyDependentContent } from 'components/LaunchDarklyDependentContent/LaunchDarklyDependentContent'
import { ExternalRedirect } from 'components/ExternalRedirect/ExternalRedirect'
import { useMedicareUrl } from 'hooks/useMedicareUrl'
//  TODO - rename this file as well
export const AccountSettingsRoutes: React.FC<{}> = () => {
  // TODO - later ticket for oauthRedirectUrl
  // Pull from SEO.data, and have SEO data have a util function for generating the "matched paths"
  const match = useRouteMatch()
  const matchedPath = match.path
  const routes = {
    accountSettings: `${matchedPath}/`,
    authRep: `${matchedPath}/auth-rep`,
    addAuthRep: `${matchedPath}/auth-rep/new`,
    editAuthRep: `${matchedPath}/auth-rep/edit/:id`,
    getMyMedicareCard: `${matchedPath}/get-my-medicare-card`
  }

  const legacyAuthRepUrl = useMedicareUrl(
    'https://www.medicare.gov/mbp/authorizedRep.aspx',
    'https://www.medicare.gov/mbp/authorizedRep.aspx?Lang=es-mx'
  )

  const legacyAccountSettingsUrl = useMedicareUrl(
    'https://www.medicare.gov/mbp/myaccount.aspx',
    'https://www.medicare.gov/mbp/myaccount.aspx?Lang=es-mx'
  )

  return (
    <div className='my-c-authrep'>
      <Switch>
        <AuthenticatedRoute exact path={routes.authRep} redirectPath={routes.authRep}>
          <LaunchDarklyDependentContent
            flagName='authRep'
            fallbackContent={<ExternalRedirect url={legacyAuthRepUrl} />}
          >
            <AuthRep />
          </LaunchDarklyDependentContent>
        </AuthenticatedRoute>
        <AuthenticatedRoute exact path={routes.addAuthRep} redirectPath={routes.authRep}>
          <LaunchDarklyDependentContent
            flagName='authRep'
            fallbackContent={<ExternalRedirect url={legacyAuthRepUrl} />}
          >
            <AuthRepAddForm />
          </LaunchDarklyDependentContent>
        </AuthenticatedRoute>
        <AuthenticatedRoute exact path={routes.editAuthRep} redirectPath={routes.authRep}>
          <LaunchDarklyDependentContent
            flagName='authRep'
            fallbackContent={<ExternalRedirect url={legacyAuthRepUrl} />}
          >
            <AuthRepEditForm />
          </LaunchDarklyDependentContent>
        </AuthenticatedRoute>
        <AuthenticatedRoute exact path={routes.getMyMedicareCard} redirectPath={routes.accountSettings}>
          <LaunchDarklyDependentContent
            flagName='accountSettings'
            fallbackContent={<Error404 />}
          >
            <GetMyMedicareCardPage />
          </LaunchDarklyDependentContent>
        </AuthenticatedRoute>
        <AuthenticatedRoute exact path={routes.accountSettings} redirectPath={routes.accountSettings}>
          <LaunchDarklyDependentContent
            flagName='accountSettings'
            fallbackContent={<ExternalRedirect url={legacyAccountSettingsUrl} />}
          >
            <AccountSettings />
          </LaunchDarklyDependentContent>
        </AuthenticatedRoute>
        <Route>
          <Error404 />
        </Route>
      </Switch>
    </div>
  )
}
